<template>
  <InvoiceForm :invoice-id="invoiceId" />
</template>

<script>
import InvoiceForm from '~/components/pages/document-flow/InvoiceForm.vue'

export default {
  name: 'DocumentFlowInvoicesEdit',
  components: { InvoiceForm },
  computed: {
    invoiceId() {
      return this.$route.params.id
    },
  },
}
</script>
